<template>
  <div>
    <DialogWrapper
      v-if="disablePickInfo"
      dialogType="disablePickInfo"
      @closeDialog="handleCloseDialog"
    >
      <div slot="main-content" class="dialog-content-detail">
        <p>您尚未满足领取条件，</p>
        <p>点击查看详情，看看具体条件吧</p>
      </div>
      <div slot="footer" class="dialog-button">
        <button class="dialog-white-button" @click="onClickEntry('disablePickInfo', 2, 1)">
          {{ entryInfo.button_name }}
        </button>
        <button
          class="dialog-blue-button"
          @click="onGoDetail"
        >
          查看详情
        </button>
      </div>
    </DialogWrapper>
    <DialogWrapper
      v-if="gameNotActivatedInfo"
      dialogType="gameNotActivatedInfo"
      @closeDialog="handleCloseDialog"
    >
      <div slot="main-content" class="dialog-content-detail">
        <p>领取礼包需激活对应游戏，</p>
        <p>您尚未激活该游戏。</p>
        <p>下载并进入游戏即可激活</p>
      </div>
      <div slot="footer" class="dialog-button">
        <button class="dialog-blue-button" @click="downLoadGame">下载游戏</button>
      </div>
    </DialogWrapper>
    <DialogWrapper
      v-if="noBindAccountInfo"
      dialogType="noBindAccountInfo"
      @closeDialog="handleCloseDialog"
    >
      <!-- <template slot="title">领取成功</template> -->
      <div slot="main-content" class="dialog-content-detail">
        <p>您当前未绑定游戏账号，</p>
        <p>赶紧绑定，众多精彩礼包等着您</p>
      </div>
      <div slot="footer" class="dialog-button">
        <button class="dialog-blue-button" @click="bindAccount">绑定账号</button>
      </div>
    </DialogWrapper>
    <DialogWrapper v-if="noGiftInfo" dialogType="noGiftInfo" @closeDialog="handleCloseDialog">
      <div slot="main-content" class="dialog-content-detail">
        <p>很遗憾，礼包已被领取完毕，</p>
        <p>下次可要早点来呀！</p>
      </div>
      <div slot="footer" class="dialog-button">
        <button class="dialog-white-button" @click="onCallService('noGiftInfo')">联系客服</button>
        <button class="dialog-blue-button" @click="onClickEntry('noGiftInfo', 3, 1)">
          {{ entryInfo.button_name }}
        </button>
      </div>
    </DialogWrapper>
    <DialogWrapper v-if="expiredInfo" dialogType="expiredInfo" @closeDialog="handleCloseDialog">
      <div slot="main-content" class="dialog-content-detail">
        <p>当前不在领取时间范围内</p>
      </div>
      <div slot="footer" class="dialog-button">
        <button class="dialog-white-button" @click="handleCloseDialog('expiredInfo')">再逛逛</button>
      </div>
    </DialogWrapper>
    
    <DialogWrapper
      v-if="copyGiftCode"
      dialogType="copyGiftCode"
      @closeDialog="handleCloseDialog"
    >
      <template slot="title">领取成功</template>
      <div slot="main-content" class="dialog-content-detail">
        <div class="dialog-copy">
          礼包码：
          <input id="dialogGiftCode" :value="giftCode" readonly="readonly" />
        </div>
        <p class="fs_12 mt_8" style="color: #FE4F4A">礼包时间有限，请及时前往游戏中兑换</p>
      </div>
      <div slot="footer" class="dialog-button">
        <button class="dialog-white-button" @click="onClickEntry('copyGiftCode', 1, 1)">
          {{ entryInfo.button_name }}
        </button>
        <button
          id="dialogCopyBtn"
          class="dialog-blue-button"
          data-clipboard-target="#dialogGiftCode"
          @click="onClickCopy"
        >复制礼包码</button>
      </div>
    </DialogWrapper>
    <DialogWrapper
      v-if="vipGiftSuccess"
      dialogType="vipGiftSuccess"
      @closeDialog="handleCloseDialog"
    >
      <template slot="title">领取成功</template>
      <div slot="main-content" class="dialog-content-detail">
        <p>VIP礼包由客服人工发放， 点击“领取礼包”即可跳转客服聊天</p>
      </div>
      <div slot="footer" class="dialog-button">
        <button class="dialog-white-button" @click="handleCloseDialog('vipGiftSuccess')">
          再逛逛
        </button>
        <button class="dialog-blue-button" @click="vipGiftJumpLink">领取礼包</button>
      </div>
    </DialogWrapper>
    <DialogWrapper v-if="receivedGift" dialogType="receivedGift" @closeDialog="handleCloseDialog">
      <div slot="main-content" class="dialog-content-detail">
        <p>您已领取过该礼包，</p>
        <p>请前往我的礼包查看哦</p>
      </div>
      <div slot="footer" class="dialog-button">
        <button class="dialog-white-button" @click="onClickEntry('receivedGift', 6, 1)">
          {{ entryInfo.button_name }}
        </button>
        <button class="dialog-blue-button" @click="onGoMyGift">
          我的礼包
        </button>
      </div>
    </DialogWrapper>
  </div>
</template>

<script>
import DialogWrapper from './DialogWrapper';
import { Toast } from "vant";
import { pickGift } from '@/api/giftCenter.js';
import { reportData } from '@/api/report';
import { mapState, mapActions, mapMutations } from "vuex";
import Clipboard from "clipboard";
import { initEntryInfo } from '@/mixins/giftFeedbackEntryInfo'
export default {
  data() {
    return {
      disablePickInfo: false,
      gameNotActivatedInfo: false,
      noBindAccountInfo: false,
      noGiftInfo: false,
      expiredInfo: false,
      copyGiftCode: false,
      vipGiftSuccess: false,
      receivedGift: false,
      giftId: '', // 礼包id
      giftCode: '', // 礼包码
      jump_url: '', // vip跳转链接
      downLoadGameUrl: '', // 游戏下载链接
      brushFlag: false, // 防重复点击领取按钮
    };
  },
  mixins: [initEntryInfo(1, 1)],
  components: {
    DialogWrapper,
    Toast
  },
  computed: {
    ...mapState('giftCenter', {
      showGiftDialog: state => state.showGiftDialog,
      pickGiftItem: state => state.pickGiftItem
    })
  },
  watch: {
    showGiftDialog(newValue, oldValue) {
      if (newValue) {
        this.handlePickGift(this.pickGiftItem)
      }
    }
  },
  mounted() {
    this.copyInit();
    this.$bus.$on('showNormalDialog', (type) =>
      this.showNormalDialog(type)
    )
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_SHOW_LOADING: 'CHANGE_SHOW_LOADING',
      CHANGE_BIND_ACCOUNT_DIALOG: 'CHANGE_BIND_ACCOUNT_DIALOG'
    }),
    ...mapMutations('giftCenter', {
      SHOW_GIFT_DIALOG: 'SHOW_GIFT_DIALOG'
    }),
    copyInit() {
      this.copy = new Clipboard("#dialogCopyBtn");
      this.copy.on("success", e => {
        Toast("复制成功");
        e.clearSelection();
      });
    },
    onClickCopy () {
      this.handleTrack(1, 2)
    },
    // 关闭弹窗
    handleCloseDialog(type) {
      this[type] = false
      if (type == 'copyGiftCode' || type == 'vipGiftSuccess') {
        // 当礼包领取成功时候重新请求数据
        let { name } = this.$route
        switch (name) {
          case 'giftCenter.activatedGame':
            this.$emit('refreshActivatedGame')
            break;
          case 'giftCenter.allGift':
            this.$emit('refreshAllGift')
            break;
          case 'giftCenter.details':
            this.$emit('refreshDetails')
            break;
          case 'giftCenter.home':
            this.$emit('refreshHome')
            break;
          default:
            break;
        }
      }
    },
    // 点击领取礼包，根据结果控制弹窗的展示
    async handlePickGift(item) {
      if (this.brushFlag) return
      this.brushFlag = true
      this.giftId = item.id
      this.CHANGE_SHOW_LOADING(true)
      try {
        const r = await pickGift({ gift_set_id: this.giftId })
        if (r.code === 1) {
          switch (r.data.type) {
            case 1:
              this.vipGiftSuccess = true;
              this.jump_url = r.data.jump_url
              break;
            case 2:
              this.copyGiftCode = true;
              this.giftCode = r.data.code || '';
              break;
            default:
              break;
          }
        }
      } catch (error) {
        const { type, code, status: st, download_url } = error.data
        const status = Number(st)
        switch (status) {
          case 1:
            this.noBindAccountInfo = true
            break;
          case 4:
            this.noGiftInfo = true
            break;
          case 3:
            this.disablePickInfo = true
            break;
          case 2:
            this.gameNotActivatedInfo = true;
            this.downLoadGameUrl = download_url;
            break;
          case 5:
            this.expiredInfo = true
            break;
          default:
            break;
        }
      } finally {
        this.CHANGE_SHOW_LOADING(false)
        this.SHOW_GIFT_DIALOG(false)
        this.brushFlag = false
      }
    },
    beforeEntry (dialogType, type, subtype) {
      this.handleTrack(type, subtype)
    },
    handleTrack (type, subtype) {
      const extra = {}
      // 1 领取成功 2 未满足领取条件 3 奖励数量为0 4 未激活该游戏 5 未绑定账号 6 已领取
      // 1 其他惊喜福利 2 复制礼包码 3 查看详情 4 联系客服 5 下载游戏 6 绑定账号 7 我的礼包
      if (subtype) {
        extra.data_type = 10
        extra.extend = `${type}-${subtype}`
      }
      reportData({
        type: 10,
        gift_set_id: this.pickGiftItem.id,
        ...extra
      })
    },
    onGoDetail () {
      this.handleTrack(2, 3)
      this.handleLinkTo('giftCenter.details', { giftId: this.pickGiftItem.id })
    },
    onGoMyGift () {
      this.handleTrack(6, 7)
      this.handleLinkTo('personalCenter.myGift')
    },
    // 路由跳转
    handleLinkTo(name, query) {
      switch (name) {
        case 'giftCenter.details':
          this.handleCloseDialog('disablePickInfo')
          if (this.$route.name !== 'giftCenter.details') {
            this.$router.push({ name, query })
          }
          break;
        case 'personalCenter.myGift':
          this.$router.push({ name });
          break;
        default:
          break;
      }
    },
    // 下载游戏
    downLoadGame() {
      this.handleTrack(4, 5)
      this.handleCloseDialog('gameNotActivatedInfo')
      window.location.href = this.downLoadGameUrl;
    },
    // 绑定账号
    bindAccount() {
      this.handleTrack(5, 6)
      this.handleCloseDialog('noBindAccountInfo')
      this.CHANGE_BIND_ACCOUNT_DIALOG(true)
    },
    // vip跳转连接
    vipGiftJumpLink() {
      reportData({
        type: 10,
        data_type: 6,
        gift_set_id: this.giftId
      })
      this.handleCloseDialog('vipGiftSuccess')
      setTimeout(() => {
        window.location.href = this.jump_url;
      }, 500);
    },
    onCallService (type) {
      this.handleTrack(3, 4)
      this.handleCloseDialog(type)
      setTimeout(() => {
        this.$router.push({
          name: 'service',
        })
      }, 100)
    },
    handleJump () {
      if (this.jumpLoading) return
      this.jumpLoading = true
      setTimeout(() => {
        this.jumpLoading = false
        window.location.href = this.jump_url;
      }, 200);
    },
    // 显示普通弹窗
    showNormalDialog(type) {
      this[type] = true
    },
  }
}
</script>

<style lang='scss'>
@import '~@/styles/mixins.scss';
@import '~@/styles/variable.scss';
.dialog-content-detail {
  margin-top: 15px;
  font-size: 18px;
  line-height: 22px;
  color: #000;
  .dialog-copy {
    @include vertical-center;
    margin-top: 23px;
    width: 305.6px;
    height: 38.8px;
    input {
      @include clearBtnDefaultStyle;
      width: 210px;
      background: #EBEBEB;
      padding: 8px 12px;
      border-radius: 5px;
      font-size: 15px;
    }
    button {
      @include clearBtnDefaultStyle;
      margin-left: 15px;
      width: $buttonWidth;
      height: $buttonHeight;
      line-height: $buttonHeight;
      color: #fff;
      font-size: 10px;
      background-color: $buttonColor;
      border-radius: 15px;
    }
  }
  // p:first-of-type {
  //   margin-top: 9px;
  //   text-align: center;
  //   font-size: 13px;
  //   color: #9f9f9f;
  // }
}
</style>